import { resources } from '@/api/helpers'

export async function getFilteredData(start_date: string, end_date: string): Promise<Api.TimeEntry[]> {
	return resources
		.get('time-entries', { searchParams: { start_date: start_date, end_date: end_date } })
		.json()
}
